<template>
  <BasicSection :d="d" />
</template>

<script>
import BasicSection from "@/components/BasicSection";
export default {
  components: { BasicSection },
  name: "Introduction",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          paragraphs: []
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team",
        title: "Introduction",
        ...this.datum
      }
    };
  },
  created() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  font-size: 1.5em;
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduction.vue